import { Component, input } from '@angular/core';
import { FaDuotoneIconComponent } from "@fortawesome/angular-fontawesome";
import { TooltipDirective } from '../../core/directives/tooltip.directive';

@Component({
  selector: 'ms-input-label',
  imports: [FaDuotoneIconComponent, TooltipDirective],
  templateUrl: './input-label.component.html',
})
export class InputLabel {
  public isRequired = input<boolean>(false);
  public labelText = input<string>('')
  public class = input<string>('');
  public tooltip = input<string | undefined>(undefined);

  // The id of the control this labels. Supplying it ties the two together, which is what gives the
  // control its accessible name and makes the label a click target for it; without it the label is
  // only text sitting above an unnamed input. Optional so existing callers are unchanged.
  public controlId = input<string>('');

}
